<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Animation:</span>
    <div class="wf-w-1/2">
      <select v-model="iconAnimation" class="wf-w-full">
        <option value="ICON_NONE">None</option>
        <option value="ICON_PULSE">Pulse</option>
        <option value="ICON_SPIN">Spin</option>
      </select>
    </div>
  </li>
</template>

<script>
  import _ from "lodash";
  import { IconAnimatedClasses } from '../classes/IconAnimatedClasses'
  import MenuStyleProperty from "../contracts/MenuStyleProperty";
  export default MenuStyleProperty.extend({
    computed: {
      iconAnimationClasses() {
        return Object.keys(IconAnimatedClasses)
      },
      iconAnimation: {
        get() {
          let currentAnimation = this.elementClasses(this.classes)[this.device].find(elementClass => this.iconAnimationClasses.includes(elementClass.value))
          if (!currentAnimation) {
            currentAnimation = {property: 'IconAnimated', value: 'ICON_NONE', touched: false}
            this.addToArray(this.module, [currentAnimation], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentAnimation.value
        },
        set: _.debounce(function (value) {
          let currentAnimation = this.elementClasses(this.classes)[this.device].find(elementClass => this.iconAnimationClasses.includes(elementClass.value))
          value = {property: 'IconAnimated', value: value, touched: currentAnimation.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    }
  })
</script>
